import { Image } from '@cian/ui-kit';
import { FC } from 'react';
import { CarouselWrapper } from '../CarouselWrapper';

import styles from './EmptyCarousel.css';

export const EmptyCarousel: FC = () => {
  return (
    <CarouselWrapper className={styles['carousel--empty']}>
      <Image src="" />
    </CarouselWrapper>
  );
};
